export type UnknownRecord = Record<string, unknown>;

export const isRecord = (value: unknown): value is UnknownRecord =>
  Boolean(value) && typeof value === "object" && !Array.isArray(value);

export const toRecord = (value: unknown): UnknownRecord | null =>
  isRecord(value) ? value : null;

export const readString = (...values: unknown[]) => {
  const matched = values.find(
    (value) => typeof value === "string" && value.trim() !== "",
  );

  return typeof matched === "string" ? matched : undefined;
};

export const readNumber = (...values: unknown[]) => {
  const matched = values.find(
    (value) =>
      typeof value === "number" ||
      (typeof value === "string" && value.trim() !== ""),
  );

  if (matched === undefined) {
    return undefined;
  }

  const parsedValue = Number(matched);
  return Number.isFinite(parsedValue) ? parsedValue : undefined;
};

export const readId = (value: unknown) => {
  if (!value) {
    return "";
  }

  if (typeof value === "string") {
    return value;
  }

  const record = toRecord(value);

  if (record) {
    if ("_id" in record) {
      return String(record._id ?? "");
    }

    if ("id" in record) {
      return String(record.id ?? "");
    }
  }

  return String(value);
};

export const unwrapData = <T = unknown>(payload: unknown): T => {
  const record = toRecord(payload);

  if (!record || !("data" in record)) {
    return payload as T;
  }

  return record.data as T;
};
